export abstract class PortalRoutesConstants {
  static readonly MAIN = "portal";
  static readonly HOME = "home";
  static readonly ADMIN = "admin";

  static readonly main = (): string => `/${PortalRoutesConstants.MAIN}`;
}
